module.exports = __webpack_public_path__ + "img/mmi-about-photo-team-nad.99305f02.png";